import { render, staticRenderFns } from "./ApplicableLaw.vue?vue&type=template&id=1659b155&"
import script from "./ApplicableLaw.vue?vue&type=script&lang=js&"
export * from "./ApplicableLaw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/apps/hemmelig/components/contract/ApplicableLaw.vue
// module id = null
// module chunks = 